import React, { useEffect, useState, useCallback } from 'react';
import { registerConfirmHost, DISCARD_MESSAGE } from './confirmDiscard';
import './ConfirmDialog.css';

// Single mounted host that backs confirmDiscard(). It renders the app's own
// styled confirm — a centered modal on desktop, a bottom sheet on mobile —
// instead of the native window.confirm. confirmDiscard() hands us a resolver;
// the user's choice (Discard = true, Keep editing / dismiss = false) resolves it.
export default function DiscardConfirmHost() {
  const [resolver, setResolver] = useState(null);
  const open = resolver !== null;

  useEffect(() => {
    registerConfirmHost((resolve) => setResolver(() => resolve));
    return () => registerConfirmHost(null);
  }, []);

  const finish = useCallback((value) => {
    setResolver(prev => { if (prev) prev(value); return null; });
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') finish(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, finish]);

  if (!open) return null;

  return (
    <div className="confirm-backdrop" role="presentation" onClick={() => finish(false)}>
      <div className="confirm-dialog" role="alertdialog" aria-modal="true" aria-label="Unsaved changes"
        onClick={e => e.stopPropagation()}>
        <div className="confirm-dialog-title">Unsaved changes</div>
        <p className="confirm-dialog-msg">{DISCARD_MESSAGE}</p>
        <div className="confirm-dialog-actions">
          <button className="confirm-keep-btn" onClick={() => finish(false)} autoFocus>Keep editing</button>
          <button className="confirm-discard-btn" onClick={() => finish(true)}>Discard changes</button>
        </div>
      </div>
    </div>
  );
}
